import axios from "axios";
import Notice from "./notice.base";
import router from "../router/router.js";
import { Loading } from "element-ui";
import { MAINTENANCE_DOMAIN } from "@/utils/options.js";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

let host = "";
if (process.env.NODE_ENV === "development")
  host = "http://127.0.0.1:10082/api/";
// else host = "https://8.219.216.55/api/";
else host = `${MAINTENANCE_DOMAIN}/api/`;

axios.defaults.baseURL = host;
axios.defaults.validateStatus = function(status) {
  // 更改状态码 不怎么用   状态码在大于或等于500时才会 reject
  return status < 600;
};

let loadingInstance;
let redirectingToLogin = false;

const noAuthPaths = ["/stable-firmware", "/beta-firmware"];

function errorCode(payload) {
  if (!payload || typeof payload !== "object") return null;
  let code = null;
  if (payload.code !== undefined && payload.code !== null) {
    code = Number(payload.code);
    if (code === 401 || code === 4001) return code;
  }
  if (payload.data && typeof payload.data === "object") {
    const nestedCode = errorCode(payload.data);
    if (nestedCode !== null) return nestedCode;
  }
  return code;
}

function isAuthenticationFailure(error, payload) {
  const responseStatus = error && error.response && error.response.status;
  const status = error && error.status;
  return (
    responseStatus === 401 ||
    status === 401 ||
    errorCode(error) === 401 ||
    errorCode(error) === 4001 ||
    errorCode(payload) === 401 ||
    errorCode(payload) === 4001
  );
}

function redirectToLogin() {
  if (noAuthPaths.includes(router.currentRoute.path)) return;

  localStorage.removeItem("token");
  localStorage.removeItem("id");
  localStorage.removeItem("username");
  localStorage.removeItem("is_admin");
  localStorage.removeItem("email");
  localStorage.removeItem("mobile");
  localStorage.removeItem("department");
  localStorage.removeItem("macRecord");
  localStorage.removeItem("ipRecord");

  if (router.currentRoute.path === "/login" || redirectingToLogin) return;
  redirectingToLogin = true;
  const redirect = router.currentRoute.fullPath;
  const navigation = router.replace({ path: "/login", query: { redirect } });
  if (navigation && typeof navigation.then === "function") {
    navigation.then(() => {
      redirectingToLogin = false;
    }).catch(() => {
      redirectingToLogin = false;
    });
  } else {
    redirectingToLogin = false;
  }
}

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    loadingInstance = Loading.service();
    if (config.url != "login/") {
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    let data = response.data;
    loadingInstance.close();
    // Handle both proper HTTP 401 responses and the legacy wrapped auth error.
    if (isAuthenticationFailure(response, data)) {
      redirectToLogin();
      return Promise.reject(data);
    }
    if (response.status >= 400) return Promise.reject(data);
    // console.log("response.data" ,data)
    return data;
  },
  function(error) {
    loadingInstance.close();
    return Promise.reject(error);
  }
);

// 遵守 RESETful 规范,对应增删改查方法
export default class HttpRequest {
  constructor() {
    this.http = axios;
    this.host = host;
  }

  get(url, params, successCall, errorCall = () => {}) {
    this.http
      .get(url, {
        params
      })
      .then(successCall)
      .catch(createRejection(errorCall));
  }

  post(url, params, successCall, errorCall = () => {}) {
    // let newParams = new URLSearchParams();
    // for (let i in params) newParams.append(i, params[i]);
    this.http
      .post(url, params)
      .then(successCall)
      .catch(createRejection(errorCall));
  }

  postOptions(url, params, options, successCall, errorCall = () => {}) {
    // let newParams = new URLSearchParams();
    // for (let i in params) newParams.append(i, params[i]);
    this.http
      .post(url, params, {
        ...options,
        onUploadProgress: options.onUploadProgress
      })
      .then(successCall)
      .catch(createRejection(errorCall));
  }

  put(url, params, successCall, errorCall = () => {}) {
    // let newParams;
    // if (
    //   url.indexOf("roles") != -1 ||
    //   url.indexOf("users") != -1 ||
    //   url.indexOf("account") != -1
    // ) {
    //   newParams = params;
    // } else {
    //   newParams = new URLSearchParams();
    //   for (let i in params) newParams.append(i, params[i]);
    // }
    this.http
      .put(url, params)
      .then(successCall)
      .catch(createRejection(errorCall));
  }

  patch(url, params, successCall, errorCall = () => {}) {
    let newParams = new URLSearchParams();
    for (let i in params) newParams.append(i, params[i]);
    this.http
      .patch(url, newParams)
      .then(successCall)
      .catch(createRejection(errorCall));
  }

  delete(url, successCall, errorCall = () => {}) {
    this.http
      .delete(url)
      .then(successCall)
      .catch(createRejection(errorCall));
  }

  multipleDelete(url, params, successCall, errorCall = () => {}) {
    this.http
      .delete(url, { params })
      .then(successCall)
      .catch(createRejection(errorCall));
  }
}

let notice = new Notice();

function createRejection(callback) {
  return error => {
    if (isAuthenticationFailure(error)) {
      redirectToLogin();
    } else {
      notice.messageBox("alert", error.msg, "出错了", "error")(() => {});
    }
    callback(error);
  };
}
